var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import MultiSelect from './multi-select';
// Recursively filter the tree so that if an item’s label matches the query or any of its descendants match, it is kept.
function filterTree(items, query) {
    const filteredItems = items.reduce((acc, item) => {
        let matched = item.name.toLowerCase().includes(query.toLowerCase());
        let filteredChildren = item.children
            ? filterTree(item.children, query)
            : [];
        if (filteredChildren.length > 0) {
            matched = true;
        }
        if (matched) {
            acc.push(Object.assign(Object.assign({}, item), { children: filteredChildren }));
        }
        return acc;
    }, []);
    return filteredItems;
}
// Flatten the hierarchical tree and record each item's level for indentation
function flattenTree(items, level = 0) {
    return items.reduce((acc, item) => {
        const { children } = item, rest = __rest(item, ["children"]);
        acc.push(Object.assign(Object.assign({}, rest), { level, children }));
        if (children && children.length > 0) {
            acc.push(...flattenTree(children, level + 1));
        }
        return acc;
    }, []);
}
function getSelectedOptionLabelWithParents(option, folderMap) {
    const path = [];
    let current = option;
    while (current) {
        path.unshift(current.name);
        current = current.parentValue ? folderMap[current.parentValue] : undefined;
    }
    return path.join(' / ');
}
export const MultiSelectHierarchy = (props) => {
    const options = useMemo(() => flattenTree(props.options), [props.options]);
    const optionsMapByValue = useMemo(() => options.reduce((acc, item) => {
        acc[item.value] = item;
        return acc;
    }, {}), [options]);
    return (_jsx(MultiSelect
    // Custom equality check to resolve the selection error.
    , Object.assign({ 
        // Custom equality check to resolve the selection error.
        isOptionEqualToValue: (option, value) => option.name === value.name && option.level === value.level, 
        // Override the filtering logic to include parent nodes if any child matches.
        filterOptions: (options, { inputValue }) => {
            if (!inputValue)
                return options;
            const filteredTree = filterTree(props.options, inputValue);
            return flattenTree(filteredTree);
        }, getOptionLabel: (option) => getSelectedOptionLabelWithParents(option, optionsMapByValue), renderOption: (props, option) => (_jsx("li", Object.assign({}, props, { children: _jsx("span", { style: { paddingLeft: (option.level || 0) * 20 }, children: option.name }) }))) }, props, { options: options })));
};
export default MultiSelectHierarchy;
